// We use Modernizr for feature detection
import Modernizr from 'modernizr';

function loadScript (src) {
  var js = document.createElement('script');
  js.src = src;

  js.onerror = function() {
    new Error('Failed to load script ' + src);
  };

  document.head.appendChild(js);
}

function runTests () {
  // Feature detection for outdated browsers
  if (!Modernizr.flexbox) {
    return window.location.href = '/browser-warning';
  }

  if (!Modernizr.intersectionobserver) {
    // Polyfill Safari and IE11 so we can use intersection observer
    loadScript('https://polyfill.io/v2/polyfill.min.js?features=IntersectionObserver');
  }
}

runTests();


// WEBPACK FOOTER //
// ./resources/assets/js/app/feature-test.js